export default __webpack_public_path__ + "static/media/visa-2.f2e450f6.png";